import { useState } from "react";
import TextField from "@mui/material/TextField";
import { AssignmentRequest } from "protogen/assignments_pb";
import { useExtendAssignmentExpiration } from "services/signup";
import ReactiveDialog from "components/common/ReactiveDialog";
type Props = {
  isOpen: boolean;
  onClose: () => void;
  assignment: AssignmentRequest;
};

export default ({ isOpen, onClose, assignment }: Props) => {
  const {
    request: extendAssignmentExpiration,
    loading: extendingAssignmentExpiration,
  } = useExtendAssignmentExpiration();
  const [minutesToExtend, setMinutesToExtend] = useState(0);
  const confirm = async () => {
    await extendAssignmentExpiration({
      assignmentRef: assignment.ref,
      minutesToAdd: minutesToExtend,
    });
    onClose();
  };
  return (
    <ReactiveDialog
      primaryAction={confirm}
      primaryActionName={"Extend"}
      fullWidthSize="sm"
      primaryActionEnabled={!extendingAssignmentExpiration}
      open={isOpen}
      onClose={onClose}
      title={`Extend expiration`}
    >
      <TextField
        label="Minutes to extend"
        value={minutesToExtend}
        onChange={(e) => setMinutesToExtend(Number(e.target.value))}
      />
    </ReactiveDialog>
  );
};
